<template>
	<div class="webview-weather-forecast">
		<sorry-page v-if="isError" @reload="getData" class="webview-weather-forecast__inner" />

		<v-ons-page v-else-if="isMount" class="webview-weather-forecast__inner">
			<div class="content">
				<!-- ヘッダー -->
				<h1 v-if="isMultipleLocation" class="webview-weather-forecast__points">
					<div class="webview-weather-forecast__points--inner swiper-container" id="js_points_swiper">
						<ul class="webview-weather-forecast__points--list swiper-wrapper">
							<li
								v-for="(item, index) in cityCodes"
								:key="`point-${index}`"
									:class="[
									'webview-weather-forecast__points--item',
									'swiper-slide',
									{ 'is-active' : item.city_code === cityCode}
								]"
							>
								<a v-if="index === 0" href="javascript:void(0);" @click="onChangeCityCode(item.city_code, index, true)">
									<em>現在地</em>
									<span>{{ item.city_name }}</span>
								</a>
								<a v-else href="javascript:void(0);" @click="onChangeCityCode(item.city_code, index, true)">{{ item.city_name }}</a>
							</li>
						</ul>
					</div>
					<a class="webview-weather-forecast__points--button gtm-link_click_count01" href="native://open_regist_weather_point" data-gtm-event-cat-label="天気予報Webview複数地点登録ボタン" data-gtm-event-act-label="trackingWebviewWeatherForecast_multipleLocation">
						<svg viewBox="0 0 19 20" fill="none">
							<path d="M7.2036 0C6.25746 8.78501e-05 5.32061 0.184899 4.44654 0.543881C3.57246 0.902863 2.7783 1.42899 2.10938 2.09221C1.44045 2.75543 0.90987 3.54275 0.547943 4.40922C0.186016 5.27569 -0.000177173 6.20434 1.26503e-07 7.14214C1.26503e-07 11.0855 7.2036 20 7.2036 20C7.2036 20 14.4079 11.0855 14.4079 7.14214C14.408 6.20431 14.2217 5.27564 13.8597 4.40917C13.4977 3.54269 12.967 2.75538 12.2981 2.09217C11.6291 1.42896 10.8349 0.902844 9.96076 0.543871C9.08665 0.184897 8.14977 8.78572e-05 7.2036 0ZM7.2036 9.38481C6.75583 9.38481 6.31813 9.2532 5.94582 9.00663C5.57352 8.76006 5.28333 8.40959 5.11198 7.99955C4.94063 7.58951 4.8958 7.13832 4.98315 6.70302C5.07051 6.26773 5.28612 5.86789 5.60274 5.55406C5.91936 5.24023 6.32276 5.02651 6.76193 4.93992C7.20109 4.85333 7.6563 4.89777 8.06999 5.06761C8.48367 5.23746 8.83724 5.52507 9.08601 5.8941C9.33477 6.26312 9.46755 6.69698 9.46755 7.1408C9.46755 7.73595 9.22903 8.30673 8.80446 8.72756C8.37988 9.14839 7.80404 9.38481 7.2036 9.38481Z" fill="#1EBFBB"/>
							<path d="M12.6 15.1653H18" stroke="#1EBFBB" stroke-width="2" stroke-linecap="round"/>
							<path d="M15.2999 12.489L15.2999 17.8414" stroke="#1EBFBB" stroke-width="2" stroke-linecap="round"/>
						</svg>
					</a>
				</h1>
				<h1 v-else class="webview-weather-forecast__title">{{ cityCodes[0].city_name }}</h1>

				<!-- お知らせ -->
				<weather-information @setInformationNumber="informationNumber = $event" />
				<!-- /お知らせ -->

				<!-- 天気予報 -->
				<section class="webview-weather-forecast__item is-weather-forecast">
					<weather-forecast :key="cityCode" :cityCode="cityCode" />
				</section>
				<!-- /天気予報 -->

				<!-- 広告（アドマネージャー）「320*100」（Andorid） -->
				<div v-if="isAdvertisementDisplayFlag && !isPremium && isAndroid && !isR18" id='div-gpt-ad-1666592155251-0' style='width: 320px; height: 100px;' class="webview-weather-forecast__ad">
					<script type="application/javascript">
						googletag.cmd.push(function() { googletag.display('div-gpt-ad-1666592155251-0'); });
					</script>
					<!-- NOTE: アドセンスのコードは残しておく  -->
					<!-- <script type="application/javascript" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1580328980908756" crossorigin="anonymous"></script>
					<ins
						class="adsbygoogle"
						style="display:inline-block;width:320px;height:100px"
						data-ad-client="ca-pub-1580328980908756"
						data-ad-slot="7928601453"
					></ins>
					<script type="application/javascript">
						(adsbygoogle = window.adsbygoogle || []).push({});
					</script> -->
				</div>
				<!-- /広告（アドマネージャー）「320*100」（Andorid） -->

				<!-- NOTE: 広告（アドマネージャー）「320*100」（ios） -->
				<div v-else-if="isAdvertisementDisplayFlag && !isPremium && !isAndroid && !isR18" id='div-gpt-ad-1661170141676-0' style='width: 320px; height: 100px;' class="webview-weather-forecast__ad">
					<script type="application/javascript">
						googletag.cmd.push(function() { googletag.display('div-gpt-ad-1661170141676-0'); });
					</script>
				</div>
				<!-- /広告（アドマネージャー）「320*100」（ios） -->

				<!-- 広告（イーライリリー）「300*250」（iOS, Andorid） -->
				<div v-else-if="isAdvertisementDisplayFlag && !isPremium && isR18" class="webview-weather-forecast__ad">
					<a
						href="https://zutool.jp/henzutsu_webinar/index.html"
						rel="noopener noreferrer"
						class="gtm-link_click_count01"
						data-gtm-event-cat-label="天気予報Webviewイーライリリー広告クリック"
						data-gtm-event-act-label="trackingWebviewWeatherForecast_eliLilly"
					>
						<img src="@/assets/img/advertisement/eli_lilly_300x250.jpg" alt="オンライン市民公開講座">
					</a>
				</div>
				<!-- 広告（イーライリリー）「300*250」（iOS, Andorid） -->

				<!-- 週間天気 -->
				<section class="webview-weather-forecast__item is-weekly-weather">
					<!-- 会員 -->
					<weekly-weather v-if="isPremium" :key="cityCode" :cityCode="cityCode" />
					<!-- /会員 -->

					<!-- 非会員 -->
					<div v-else class="non-member">
						<!-- NOTE: 変更前のデザイン <p class="non-member__img"><img src="~@/assets/img/weekly_weather_non_member.png" alt="プレミアムサービスのご案内 天気予報&amp;気圧アラートが10日先まで見られる！ 予定を立てる時にも天気&amp;気圧予報を役立ててほしいニャー"></p>
						<div class="non-member__link">
							<p class="non-member__link--text">
								<svg xmlns="http://www.w3.org/2000/svg" width="10.814" height="14.581" viewBox="0 0 10.814 14.581">
									<line x2="10" y2="14" transform="translate(0.407 0.291)" fill="none" stroke="#707070" stroke-width="1" />
								</svg>
								<span>初回限定・14日間無料でお試し!</span>
								<svg xmlns="http://www.w3.org/2000/svg" width="10.814" height="14.581" viewBox="0 0 10.814 14.581">
									<line x1="10" y2="14" transform="translate(0.407 0.291)" fill="none" stroke="#707070" stroke-width="1" />
								</svg>
							</p>
							<a
								class="non-member__link--button gtm-link_click_count01"
								href="native://open_subscribe_page"
								:data-gtm-event-cat-label="`天気予報_週間天気_非会員ボタン_${isAndroid ? 'android' : 'iOS'}`"
								:data-gtm-event-act-label="`trackingWeatherForecast_weeklyWeather_nonMemberButton_${isAndroid ? 'android' : 'iOS'}`"
							>
								詳しくはこちらをチェック
							</a>
						</div> -->
						<p class="non-member__img"><img src="~@/assets/img/weekly_weather_non_member.png" alt="プレミアムサービスのご案内 天気予報&amp;気圧アラートが10日先まで見られる！ 予定を立てる時にも天気&amp;気圧予報を役立ててほしいニャー"></p>
						<div class="non-member__link">
							<p class="non-member__link--text">
								<svg xmlns="http://www.w3.org/2000/svg" width="10.814" height="14.581" viewBox="0 0 10.814 14.581">
									<line x2="10" y2="14" transform="translate(0.407 0.291)" fill="none" stroke="#707070" stroke-width="1" />
								</svg>
								<span>初回限定・14日間無料でお試し!</span>
								<svg xmlns="http://www.w3.org/2000/svg" width="10.814" height="14.581" viewBox="0 0 10.814 14.581">
									<line x1="10" y2="14" transform="translate(0.407 0.291)" fill="none" stroke="#707070" stroke-width="1" />
								</svg>
							</p>
							<a
								class="non-member__link--button gtm-link_click_count01"
								href="native://open_subscribe_page"
								:data-gtm-event-cat-label="`天気予報_週間天気_非会員ボタン_${isAndroid ? 'android' : 'iOS'}`"
								:data-gtm-event-act-label="`trackingWeatherForecast_weeklyWeather_nonMemberButton_${isAndroid ? 'android' : 'iOS'}`"
							>
								詳しくはこちらをチェック
							</a>
						</div>
					</div>
					<!-- /非会員 -->
				</section>
				<!-- /週間天気 -->

				<!-- ペット指数 -->
				<section v-show="computedIsCurrentLocationView" class="webview-weather-forecast__item is-pet-index">
					<pet-index-top />
				</section>
				<!-- /ペット指数 -->

				<!-- 健康天気指数 -->
				<section id="linkHealthWeather" class="webview-weather-forecast__item is-health-weather">
					<health-weather :key="cityCode" :cityCode="cityCode" />
				</section>
				<!-- /健康天気指数 -->

				<!-- 服装指数 -->
				<section class="webview-weather-forecast__item is-clothes-index">
					<clothes-index />
				</section>
				<!-- /服装指数 -->

				<!-- 広告（アドマネージャー）「300*250」（Android） -->
				<div v-if="isAdvertisementDisplayFlag && !isPremium && isAndroid" id='div-gpt-ad-1666592024900-0' style='width: 300px; height: 250px;' class="webview-weather-forecast__ad">
					<script type="application/javascript">
						googletag.cmd.push(function() { googletag.display('div-gpt-ad-1666592024900-0'); });
					</script>
					<!-- NOTE: アドセンスのコードは残しておく  -->
					<!-- <script type="application/javascript" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1580328980908756" crossorigin="anonymous"></script>
					<ins
						class="adsbygoogle"
						style="display:inline-block;width:300px;height:250px"
						data-ad-client="ca-pub-1580328980908756"
						data-ad-slot="7988859941"
					></ins>
					<script type="application/javascript">
						(adsbygoogle = window.adsbygoogle || []).push({});
					</script> -->
				</div>
				<!-- /広告（アドマネージャー）「300*250」（Android） -->

				<!-- 広告（アドマネージャー）「300*250」(ios) -->
				<div v-else-if="isAdvertisementDisplayFlag && !isPremium && !isAndroid" id='div-gpt-ad-1661169962020-0' style='width: 300px; height: 250px;' class="webview-weather-forecast__ad">
					<script type="application/javascript">
						googletag.cmd.push(function() { googletag.display('div-gpt-ad-1661169962020-0'); });
					</script>
				</div>
				<!-- /広告（アドマネージャー）「300*250」(ios) -->

				<!-- 全国マップ -->
				<section class="webview-weather-forecast__item is-thumbnail-weather-map">
					<h2 class="webview-weather-forecast__item--title">全国の天気予報</h2>
					<p class="webview-weather-forecast__item--text">今日・明日・明後日までの全国の天気予報</p>
					<a href="native://open_national_map" class="thumbnail-weather-map__wrapper gtm-link_click_count01" data-gtm-event-cat-label="天気予報Webview全国マップサムネイル" data-gtm-event-act-label="trackingWebviewWeatherForecast_weatherMap">
						<thumbnail-weather-map @canvasDataUrl='dataUrl = $event' />
					</a>

					<!-- シェアボタン -->
					<a
						href="javascript:void(0);"
						@click="onShare($event)"
						:class="[
							'webview-weather-forecast__share',
							'gtm-link_click_count01',
							{ 'is-disabled': dataUrl === '' }
						]"
						data-gtm-event-cat-label="天気予報Webviewシェアボタン"
						data-gtm-event-act-label="trackingWebviewWeatherForecast_share"
					>
						<svg class="webview-weather-forecast__share--icon" id="アイコン" xmlns="http://www.w3.org/2000/svg" width="29" height="26" viewBox="0 0 29 26">
							<rect width="26" height="26" fill="#fff"/>
							<g transform="translate(4.706 1.339)">
								<path d="M457.885,281.295l-5.28-4.454-5.28,4.454,1,1.182,3.508-2.958v13.8h1.548v-13.8l3.508,2.958Z" transform="translate(-443.928 -276.841)" fill="#1ebfbb"/>
								<path d="M456.408,284.681v1.547h3.612v11.555H445.762V286.228h3.612v-1.547h-5.16V299.33h17.354V284.681Z" transform="translate(-444.214 -276.121)" fill="#1ebfbb"/>
							</g>
						</svg>
						<span class="webview-weather-forecast__share--text">シェアする</span>
					</a>
					<!-- /シェアボタン -->
				</section>
				<!-- /全国マップ -->

				<!-- 占い -->
				<section class="webview-weather-forecast__item is-fortune-telling">
					<fortune-telling />
				</section>
				<!-- /占い -->
			</div>
		</v-ons-page>

		<!-- お知らせ詳細モーダル -->
		<v-ons-modal :visible="informationNumber !== ''" animation="fade" animationOptions="{ duration: 0.2, timing: 'ease-in' }">
			<aside class="webview-weather-forecast__information-detail">
				<!-- 台風番号が変わるたびに都度再マウントしたいのでkeyをバインドするようにした（Vueコンポーネントはkeyが変更されるたびに再マウントされる仕様） -->
				<weather-information-detail :key="informationNumber" :informationNumber="informationNumber" @setInformationNumber="informationNumber = $event" />
			</aside>
		</v-ons-modal>
		<!-- /お知らせ詳細モーダル -->
	</div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_USER_ID, SET_USER_TOKEN, SET_IS_WEBVIEW, SET_USER_DATA, SET_PREMIUM_TYPE, SET_S3_CITY_CODE_DATA } from '../store/modules/common/mutation-types'

// ライブラリ
import Swiper from 'swiper'
import cmnConst from '@/assets/js/constant.js'
import MunicipalCodeUtil from '@/utils/municipal-code-util'
import moment from 'moment'

// Compornents
import ThumbnailWeatherMap from '@/components/Organisms/ThumbnailWeatherMap'
import WeatherForecast from '@/components/Organisms/WeatherForecast'
import HealthWeather from '@/components/Organisms/HealthWeather'
import WeatherInformation from '@/components/Organisms/WeatherInformation'
import WeatherInformationDetail from '@/components/Organisms/WeatherInformationDetail'
import WeeklyWeather from '@/components/Organisms/WeeklyWeather'
import ClothesIndex from '@/components/Organisms/ClothesIndex'
import SorryPage from '@/views/SorryPage'
import FortuneTelling from '@/components/Organisms/FortuneTelling.vue'
import PetIndexTop from '@/components/Organisms/PetIndexTop.vue'

moment.locale('ja')

const STORAGE_KEY = 'preCityCode'

export default {
	name: 'WebviewWeatherForecast',
	components: {
		ThumbnailWeatherMap,
		WeatherForecast,
		HealthWeather,
		WeatherInformation,
		WeatherInformationDetail,
		WeeklyWeather,
		ClothesIndex,
		SorryPage,
		FortuneTelling,
		PetIndexTop
	},
	data () {
		return {
			isError: false,
			isMount: false,
			isMultipleLocation: true,
			isAdvertisementDisplayFlag: process.env.VUE_APP_PLATFORM === 'prod_au' || process.env.VUE_APP_PLATFORM === 'dev_au',
			userId: null,
			userToken: null,
			isPremium: false,
			dataUrl: '',
			cityCodes: [
				{
					city_code: '',
					city_name: ''
				}
			],
			cityCode: null,
			informationNumber: '',
			swiper: null,
			isChange: false,
			isR18: false
		}
	},
	created () {
		// TODO: getWeatherIndexを3コンポーネントでリクエストしている。リクエスト数を減らす意味でもここで最大日数の日別データをリクエストして、成功したらコンポーネントをマウントし各コンポーネントで必要な日数分のデータを利用するほうがパフォーマンス良さそう。

		// アプリのwebviewはスマパスのS3に置くので、スマパスのみ。現状スゴ得ではルーティングされないのでスゴ得アクセスのエラー判定はしない
		this.SET_IS_WEBVIEW(true)
		// URLパラメータをチェック
		const state = this.$route.query.state ? this.$route.query.state.toString() : ''
		const stateArray = state.split(cmnConst.SEPARATOR)
		if (state === 'error' || state === '') {
			// 認証エラー
			console.log('state error: ', state)
			this.isError = true
		} else if (stateArray.length !== 2) {
			// 認証パラメータエラー
			console.log('state length error: ', state)
			this.isError = true
		} else {
			// URLパラメータからユーザーID、ユーザートークンを取得する
			this.userId = stateArray[0]
			this.userToken = stateArray[1]
			this.SET_USER_ID(this.userId)
			this.SET_USER_TOKEN(this.userToken)

			// APIリクエスト処理
			this.getData()
		}
	},
	mounted () {
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userData', 'premiumType', 's3CityCodeData', 'isAndroid']),

		// 現在地＋androidスゴ得以外のみ表示したいコンテンツの表示フラグ
		computedIsCurrentLocationView () {
			return this.cityCode === this.cityCodes[0].city_code && !(this.premiumType.premium_type_code === 8 && this.isAndroid)
		}
	},
	methods: {
		// map Vuex actions
		...mapActions('common', [SET_USER_ID, SET_USER_TOKEN, SET_IS_WEBVIEW, SET_USER_DATA, SET_PREMIUM_TYPE, SET_S3_CITY_CODE_DATA]),

		// データ取得処理
		getData () {
			// 状態の初期化
			this.isError = false
			this.isMount = false

			// NOTE: ユーザー情報と課金タイプとS3の地点データを取得したら子コンポーネントをマウントする（必ずここで取得するのでユーザー情報/課金タイプ/S3地点データがあるかどうかの判定はしない）
			const SET_USER_DATA = this.SET_USER_DATA({
				user_id: this.userId,
				user_token: this.userToken
			})
			const SET_PREMIUM_TYPE = this.SET_PREMIUM_TYPE({
				user_id: this.userId,
				user_token: this.userToken
			})
			const SET_S3_CITY_CODE_DATA = this.SET_S3_CITY_CODE_DATA()
			Promise.all([SET_USER_DATA, SET_PREMIUM_TYPE, SET_S3_CITY_CODE_DATA]).then(res => {
				console.log('userData: ', this.userData)
				console.log('premiumType: ', this.premiumType)
				// console.log('s3CityCodeData: ', this.s3CityCodeData)

				// イーライリリー表示関係処理
				// 「2024/6/29（土）16:00」以前かつ年齢判定フラグが18歳以上の場合は表示
				const today = moment(new Date()).format()
				const endDay = moment(new Date('2024-06-29 16:00:00')).format()
				const displayFlag = endDay >= today
				if (this.userData.is_r18 && displayFlag) this.isR18 = true

				// 現在地の設定
				const municipalCodeUtil = new MunicipalCodeUtil(this.s3CityCodeData)
				this.cityCodes[0].city_code = this.userData.city_code
				this.cityCodes[0].city_name = municipalCodeUtil.getMunicipalData(this.userData.city_code).name
				let indexCityCode = 0

				// 複数地点未対応Verのフォールバック処理
				this.isMultipleLocation = typeof this.$route.query.is_multiple_location !== 'undefined'

				if (this.isMultipleLocation) {	// 複数地点対応Ver
					// 登録地点の設定
					const arrayCityCodes = this.userData.extra_city_codes ? this.userData.extra_city_codes : []
					for (let i = 0, len = arrayCityCodes.length; i < len; i++) {
						const cityCode = arrayCityCodes[i]
						if (this.cityCodes[0].city_code !== cityCode) {
							this.cityCodes.push({
								city_code: cityCode,
								city_name: municipalCodeUtil.getMunicipalData(cityCode).name
							})
						}
					}

					// 表示地点の設定(デフォルトは現在地、cookieに保存されていればそちらを優先する)
					const cookies = document.cookie
					const array = cookies.split(';')
					let cookieCityCode = null
					array.forEach(value => {
						const content = value.split('=')
						if (STORAGE_KEY === String(content[0]).trim()) cookieCityCode = String(content[1]).trim()
					})
					indexCityCode = cookieCityCode ? this.cityCodes.findIndex(item => item.city_code === cookieCityCode) : 0
					console.log('cookieCityCode: ', cookieCityCode)
					console.log('indexCityCode: ', indexCityCode)
					console.log('cityCodes: ', this.cityCodes)
				} else {	// 複数地点未対応Ver
					indexCityCode = 0
				}
				// cookieに表示地点が保存されているが、地点削除等でデータがない場合はデフォルトの地点を表示する
				this.cityCode = this.cityCodes[indexCityCode] ? this.cityCodes[indexCityCode].city_code : this.cityCodes[0].city_code

				// マウント
				this.isMount = true
				this.isPremium = this.premiumType && this.premiumType.premium_type_code > 1

				// NOTE: プレミアムキャンペーンの場合、pageViewイベント
				if (this.userData.user_attribute_code && this.userData.user_attribute_code === 'PremiumOpenCP') {
					this.premiumOpenCpPageViewEvent()
				}

				// 複数地点対応VerであればSwiperの初期化
				if (this.isMultipleLocation) {
					this.$nextTick(() => { this.initSwiper(indexCityCode) })
				}
			}).catch(error => {
				// ユーザー情報取得エラー
				console.log('userData error: ', error)
				this.isError = true
			}).finally(() => {
				// アンカーリンク遷移
				if (this.$route.hash) {
					this.$nextTick(() => {
						requestAnimationFrame(() => {
							this.hashAnchorLink()
						})
					})
				}
			})
		},

		// シェアボタンのクリックイベント
		onShare (e) {
			e.preventDefault()
			if (this.dataUrl === '') return false	// Base64データがなければ何もしない
			// console.log('dataUrl: ', this.dataUrl)

			const command = {
				'method': 'native://share',
				'base64edImage': this.dataUrl
			}

			// iOS
			if (typeof webkit !== 'undefined') webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(command))	 // eslint-disable-line

			// Android
			if (typeof Android !== 'undefined') Android.execCommand(JSON.stringify(command))	 // eslint-disable-line
		},

		// NOTE: fullreleasecp_weatherForecast_pageviewイベントを発火
		premiumOpenCpPageViewEvent () {
			this.$gtag.event('fullreleasecp_weatherForecast_pageview', {
				page_path: 'WeatherForecast',
				page_name: '天気予報ページ（PremiumOpenCP）',
				premium_type: 'PremiumOpenCP_2024_01'
			})
		},

		// NOTE: Swiperの処理
		initSwiper (index) {
			this.swiper = new Swiper('#js_points_swiper', {
				slidesPerView: 'auto',
				centeredSlides: true,
				spaceBetween: 20,
				initialSlide: index
			})

			// スライドが切り替わったら地点を変更する
			const self = this
			this.swiper.on('touchEnd', function () {
				setTimeout(() => {
					if (!self.isChange) self.onChangeCityCode(self.cityCodes[this.activeIndex].city_code, this.activeIndex, false)
				}, 100)
			})
		},

		// 地点変更
		onChangeCityCode (cityCode, index, isTap) {
			if (cityCode !== this.cityCode) {
				this.cityCode = cityCode
				// タップ時はSwiperの位置を調整する
				if (isTap) this.swiper.slideTo(index, 300, false)
				// cookieに表示地点を保存する
				const now = new Date()
				now.setDate(now.getDate() + 30)
				document.cookie = `${STORAGE_KEY}=${cityCode};expires=${now.toUTCString()}`
				this.isChange = true
				setTimeout(() => {
					this.isChange = false
				}, 300)
			}
		},

		// アンカーリンク
		hashAnchorLink () {
			const id = this.$route.hash
			const formatId = id.replace('#', '')
			setTimeout(() => {
				document.getElementById(formatId).scrollIntoView({
					block: 'start'
				})
			}, '300')
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~swiper/css/swiper.min.css';
@import "../assets/sass/variable";

// NOTE: このページ限定の変数（デザインシステム外のため他での利用禁止）
$color-background: #F1F1F1;
$color-grey: #E6E6E6;
$color-orange: #FFAD00;
$spacing-12: 0.75rem;
$text-grey: #999;

.webview-weather-forecast {
	.content {
		background-color: $color-background !important;
		padding-bottom: $spacing-20;
	}
	&__inner { font-family: $family-primary; }

	// 地点名(旧)
	&__title {
		min-height: 24px;
		margin: 0;
		padding: $spacing-6 $spacing-10;
		font-family: $lp-family-tertiary;
		font-size: $font-size-12;
		line-height: $line-height-1;
		text-align: center;
		background-color: $color-grey;
		box-sizing: border-box;
		font-weight: normal;
	}

	// 地点名（複数地点）
	&__points {
		position: sticky;
		top: 0;
		left: 0;
		min-height: 38px;
		margin: 0;
		padding: $spacing-6 0 0;
		font-family: $lp-family-primary;
		font-size: $font-size-14;
		line-height: $line-height-1;
		text-align: center;
		background-color: $color-grey;
		box-sizing: border-box;
		font-weight: normal;
		z-index: 10000;

		&--inner {
			position: relative;

			&::before,
			&::after {
				content: '';
				display: block;
				position: absolute;
				width: 11.2%;
				height: 100%;
				top: 0;
				z-index: 2;
			}

			&::before {
				left: 0;
				background: linear-gradient(90deg, $color-grey 10.94%, rgba(217, 217, 217, 0.0) 100%);
			}

			&::after {
				right: 0;
				background: linear-gradient(270deg, $color-grey 69.27%, rgba(217, 217, 217, 0.0) 100%);
			}
		}

		&--list {
			width: 100%;
			height: 100%;
			align-items: stretch;
			justify-content: flex-start;
			margin: 0;
			padding: 0;
			list-style: none;
			box-sizing: border-box;
		}

		&--item {
			width: auto;
			height: auto;
			box-sizing: border-box;

			& > a {
				display: flex;
				height: 100%;
				padding: 0 $spacing-8 $spacing-2;
				justify-content: center;
				flex-direction: column;
				align-items: center;
				text-decoration: none;
				color: $text-grey;
				box-sizing: border-box;
				border-bottom: $spacing-4 solid $color-grey;

				& > em { font-style: normal; }

				& > span {
					display: block;
					margin: $spacing-2 0 0;
					font-size: $font-size-10;
					font-weight: normal;
				}
			}

			&.is-active > a {
				font-weight: bold;
				color: $_black;
				border-bottom: $spacing-4 solid $primary;
			}
		}

		&--button {
			position: absolute;
			display: block;
			width: 22px;
			right: $spacing-10;
			top: 50%;
			transform: translateY(-50%);
			z-index: 3;

			& > svg {
				display: block;
				width: 100%;
				height: auto;
			}
		}
	}

	// 共通のスタイル
	&__item {
		padding: 0 $spacing-10;

		&.is-weather-forecast {
			margin: 0;
			padding: 0;
		}

		&--title {
			font-family: $family-primary;
			color: $primary;
			border-bottom: 2px solid $primary;
			margin: 0 $spacing-10;
			font-size: $font-size-16;
		}

		&--text {
			margin: $spacing-4 0 0;
			font-size: $font-size-14;
			text-align: center;
		}
	}

	// 週間天気のスタイル
	.is-weekly-weather {
		margin-top: $spacing-10;
		padding: 0;

		// 週間天気の非会員用
		.non-member {
			position: relative;

			&__img {
				margin: 0;

				& > img {
					display: block;
					width: 100%;
				}
			}

			&__link {
				font-family: $family-primary;
				position: absolute;
				width: 100%;
				// bottom: 6.25%; デザイン変更前
				top: 52%;
				left: 0;
				margin: 0;
				text-align: center;

				&--text {
					display: flex;
					align-items: center;
					justify-content: center;
					margin: 0;
					// font-size: $font-size-12; デザイン変更前
					font-size: $font-size-14;
					@media (max-width: (350px)) {
						font-size: $font-size-12;
					}
				}

				&--button {
					display: block;
					width: 73.125%;
					margin: $spacing-2 auto 0;
					padding: $spacing-12 $spacing-18;
					// font-size: $font-size-14; デザイン変更前
					font-size: $font-size-18;
					@media (max-width: (350px)) {
						font-size: $font-size-14;
					}
					box-sizing: border-box;
					border-radius: 10px;
					background-color: $color-orange;
					color: $text-seconday;
					text-decoration: none;
					line-height: $line-height-1;
				}
			}
		}
	}

	// 健康天気指数のスタイル
	.is-health-weather {
		margin-top: $spacing-10;
		padding: $spacing-12 $spacing-10 $spacing-16;
		background-color: $background-primary;

		/deep/ .health-weather__wrapper {
			padding: 0;
			margin: 0;
		}

		/deep/ .health-weather__title {
			font-family: $family-primary;
			margin: 0 0 $spacing-10;
			padding: 0;
			font-size: $font-size-16;
			color: $primary;
			border-bottom: 2px solid $primary;

			&::before { content: none; }
		}
	}

	// ペット指数
	.is-pet-index {
		margin: $spacing-10 0;
		padding: 0;
	}

	// 全国の気温と服装の目安
	.is-clothes-index {
		padding: 0;
	}

	// 全国マップのスタイル
	.is-thumbnail-weather-map {
		margin-top: $spacing-10;
		padding: $spacing-12 0 $spacing-16;
		background-color: $background-primary;
	}

	// 今日の運勢
	.is-fortune-telling {
		margin-top: $spacing-10;
		padding: $spacing-12 $spacing-10 $spacing-16;
		background-color: $background-primary;
	}

	.thumbnail-weather-map__wrapper {
		display: block;
		width: 57.5%;
		margin: $spacing-8 auto 0;
		box-sizing: border-box;
	}

	// 広告
	&__ad {
		margin-top: $spacing-10;
		text-align: center;
	}

	// シェアボタン
	&__share {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 57.5%;
		height: 30px;
		margin: $spacing-8 auto 0;
		font-size: $font-size-12;
		text-decoration: none;
		color: $primary;
		border: 1px solid $primary;
		border-radius: 10px;
		box-sizing: border-box;

		&--icon { width: 10.596%; }
		&--text {
			padding-left: $spacing-4;
			line-height: $line-height;
		}

		@media screen and (min-width: 375px) { height: 35px; }
		@media screen and (min-width: 390px) { height: 36px; }
		@media screen and (min-width: 428px) { height: 40px; }

		&.is-disabled {
			color: $text-disabled;
			border: 1px solid $line-primary;

			svg path { fill: $text-disabled; }
		}
	}

	// お知らせ詳細モーダル
	&__information-detail {
		height: 100%;
		overflow: scroll;
	}
}
</style>
